import './foundation/_foundation';
import { nanoid } from 'nanoid';
import device from 'current-device';

// const is_mobile = () => device.mobile();
// const is_tablet = () => device.tablet();

// import Cookies from 'js-cookie';
// window.Cookies = Cookies;
// Object.assign(window, { Cookies });

import { Fancybox } from '@fancyapps/ui';

//------------------------------------

Fancybox.bind('.fcy-popup, .fcy-video, .banner-video a', {});
Fancybox.bind('.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]', {
    groupAll: true, // Group all items
});

Fancybox.bind(".fcy-album-serive", {
    groupAll: true, // Group all items
});



/** video.js */
import videojs from "!video.js";
import videojs_youtube from "videojs-youtube/dist/Youtube.min";

//------------------------------------

// admin-ajax.php
const ajaxUrl = hd.ajaxUrl;

//------------------------------------

jQuery(($) => {


    // replaceState
    // let url = new URL(window.location.href);
    // if (url.searchParams.has('added')) {
    //     url.searchParams.delete('added');
    //     window.history.replaceState(null, '', url.toString());
    // }

    //...
    const onload_events = () => {};

    onload_events();
    $(window).on('load', () => {
        onload_events();
    });
    device.onChangeOrientation(() => {
        onload_events();
    });

    /** */
    $('.variations_form').each(function () {
        // when variation is found, do something
        $(this).on('found_variation', function (event, variation) {
            if (variation.price_html !== '') {
                $(".product-details p.single-price").html(variation.price_html);
            }
        });
    });

    $(".hb_clients_design .container .gallery-design a").removeAttr("href");
    $(".hb_clients_design .container .gallery-design a").removeClass("fcy-album-serive");

    /** */
    let project_desc = $('.section.singular.service .container .content-inner-design');
    project_desc.each((index, el) => {
        const _rand = nanoid(8);
        $(el).attr('id', 'desc_' + _rand);

        let _height = $(el).outerHeight(false);
        if (_height > 1024) {
            $(el).css({'height': '700px', 'transition': 'height 0.5s ease'});
            let _viewmore_html = '<div class="viewmore-wrappers"><a class="button-link" title="Xem thêm" data-src="#desc_' + _rand + '" data-modal="false" href="javascript:;">Xem thêm</a></div>';
            $(el).append(_viewmore_html);

            $("#desc_" + _rand).find('.button-link').on('click', function (e) {
                e.preventDefault();

                let isOpen = $(el).hasClass('is-open');

                if (!isOpen) {
                    // Nếu đang thu gọn, mở rộng nội dung
                    //$(el).css({'height': 'auto', 'transition': 'max-height 0.5s ease'});
                    $(el).animate({'height': _height + 100}, 500); // Trượt mở trong 0.5s
                    $(el).find('.viewmore-wrappers').css({'padding-top': '20px'});
                    $(this).html('<span>Thu gọn</span>');
                    $(el).addClass('is-open');
                } else {
                    // Nếu đang mở rộng, thu gọn lại
                    //$(el).css({'height': '700px', 'transition': 'max-height 0.5s ease'});
                    $(el).animate({'height': '700px'}, 500); // Trượt thu lại trong 0.5s
                    $(el).find('.viewmore-wrappers').css({'padding-top': '0'});
                    $(this).html('<span>Xem thêm</span>');
                    $(el).removeClass('is-open');
                }

                //$(el).addClass('is-open');

                // $(el).animate({'height': _height}, 500); // Trượt mở trong 0.5s
                // $("#desc_" + _rand).find('.viewmore-wrappers').fadeOut();
            })

            

            //Fancybox.bind("#desc-inner .btn-viewmore", {});
        }
    });

    /** */
    
    function updateCustomPrices() {
        var product_id = $('form.variations_form').data('product_id');
        var variation_id = $('form.variations_form').find('input[name="variation_id"]').val();

        if (!variation_id) return;

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'update_custom_prices',
                product_id: product_id,
                variation_id: variation_id  
            },
            success: function(response) {
                $('.custom-price-info').html(response);
            }
        });
    }

    // Update prices when the variation is changed
    $('form.variations_form').on('woocommerce_variation_has_changed', function() {
        updateCustomPrices();
    });

    //...
    const _qty_controls = () => {

        /**qty*/
        $('.input-number-increment').off('click').on('click', function (e) {
            e.preventDefault();
            let $input = $(this).parents('.input-number-group').find('.qty');
            let val = parseInt($input.val(), 10);
            $input.val(val + 1);

            let update_cart = $('button[name="update_cart"]');
            if (update_cart.length > 0) {
                update_cart.prop('disabled', false)
            }
        });

        $('.input-number-decrement').off('click').on('click', function (e) {
            e.preventDefault();
            let $input = $(this).parents('.input-number-group').find('.qty');
            let val = parseInt($input.val(), 10);
            if (val > 1) {
                $input.val(val - 1);

                let update_cart = $('button[name="update_cart"]');
                if (update_cart.length > 0) {
                    update_cart.prop('disabled', false)
                }
            }
        });
    }

    // run
    _qty_controls();

    /** ajaxComplete */
    $( document ).ajaxComplete(function( event, xhr, settings ) {
        _qty_controls();
    });

    /** */
    const footerDropdownBtns = Array.from(document.querySelectorAll(".footer-widgets .widget_nav_menu .widget-title"));
    const footerDropdownContent = Array.from(document.querySelectorAll(".footer-widgets .widget_nav_menu"));
    footerDropdownBtns.forEach((item, i) => item.addEventListener("click", () => {
        $(footerDropdownContent[i].lastElementChild).find('ul.menu').slideToggle();
        $(footerDropdownContent[i].firstElementChild).toggleClass("open");
    }));

    //Sự kiện trigger button update_cart
    $(document).on('click', '.controls.input-number-group button', function() {
        // Tự động nhấn nút update-cart-button khi giá trị của input.qty thay đổi
        $('.woocommerce-cart button[name="update_cart"]').trigger('click');
    });

    (function($){
        var page = 1; // Starting page
        $('#load-more').on('click', function(e) {
            e.preventDefault();
            var button = $(this);

            // Get IDs of already loaded posts
            // var exclude_ids = [];
            // $('#load-list .cell').each(function() {
            //     exclude_ids.push($(this).data('post-id'));
            // });

            // Lấy ID của bài viết cuối cùng đã tải
            var last_post_id = $('#load-list .cell').last().data('post-id');
            console.log(last_post_id);

            // Lấy ID chuyên mục từ thuộc tính data
            var category_id = $('#load-list .cell').data('post-cat');

            $.ajax({
                url: ajaxUrl, // AJAX handler
                type: 'POST',
                data: {
                    action: 'load_more_posts',
                    page: page,
                    last_post_id: last_post_id,
                    category_id: category_id // Truyền các ID chuyên mục vào AJAX
                },
                beforeSend: function() {
                    button.html('<span>Loading...</span>');
                },
                success: function(response) {
                    if (response.success) {
                        // Append new posts to the list
                        $('#load-list').append(response.data);
                        page++; // Increment page count
                        button.html('<span>Xem thêm</span>');
                    } else {
                        // No more posts
                        button.html('<span>Không còn dự án nào nữa</span>');
                        button.prop('disabled', true); // Disable the button
                    }
                },
                error: function() {
                    button.text('Try Again');
                }
            });
        });
    })(jQuery);

});

//------------------------------------

/** DOMContentLoaded */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a._blank, a.blank, a[target="_blank"]').forEach((el) => {
        if (!el.hasAttribute('target') || el.getAttribute('target') !== '_blank') {
            el.setAttribute('target', '_blank');
        }

        const relValue = el.getAttribute('rel');
        if (!relValue || !relValue.includes('noopener') || !relValue.includes('nofollow')) {
            const newRelValue = (relValue ? relValue + ' ' : '') + 'noopener nofollow';
            el.setAttribute('rel', newRelValue);
        }
    });

    // javascript disable right click
    //document.addEventListener('contextmenu', event => event.preventDefault());
    // document.addEventListener('contextmenu', function (event) {
    //     if (event.target.nodeName === 'IMG') {
    //         event.preventDefault();
    //     }
    // });

    /** remove style img tag */
    document.querySelectorAll('img').forEach((el) => el.removeAttribute('style'));

    // Hàm hiển thị thông báo
    function showNotification() {
        var notification = document.querySelector('.wishlist-notification');
        if (notification) {
            notification.classList.add('show');
            setTimeout(function() {
                notification.classList.remove('show');
            }, 3000); // Ẩn sau 3 giây
        }
    }

    // Lắng nghe sự kiện click trên nút "Thêm vào Danh sách yêu thích"
    var wishlistButtons = document.querySelectorAll('.yith-wcwl-add-button');
    wishlistButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            showNotification();
        });
    });
});

//------------------------------------

/** vars */
const getParameters = (URL) =>
    JSON.parse('{"' + decodeURI(URL.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

//------------------------------------

/**
 * @param el
 * @returns {*|jQuery}
 */
function rand_element_init(el) {
    const $el = $(el);
    const _rand = nanoid(9);
    $el.addClass(_rand);

    let _id = $el.attr('id');
    if (!_id) {
        _id = _rand;
        $el.attr('id', _id);
    }

    return _id;
}

/**
 * @param url
 * @param $delay
 */
function redirect(url = null, $delay = 10) {
    setTimeout(function () {
        if (url === null || url === '' || typeof url === 'undefined') {
            document.location.assign(window.location.href);
        } else {
            url = url.replace(/\s+/g, '');
            document.location.assign(url);
        }
    }, $delay);
}

//------------------------------------

//------------------------------------